module.exports = __webpack_public_path__ + "img/upload_error.d258f018.svg";